import React from "react";
import IconEnvioPendente from "../componentsStyled/icon/Iconenviopendente";
import { Box, Button, Modal } from "@mui/material";

interface ModalEnvioPendenteProps {
  isOpen: boolean;
  children?: React.ReactNode;
  onRequestClose: () => void;
}

const ModalEnvioPendente: React.FC<ModalEnvioPendenteProps> = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onRequestClose}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: 1,
        width: 300,
        height: "fit-content",
        bgcolor: "#fff",
        boxShadow: 24,
        "& .MuiBackdrop-root": { backgroundColor: "transparent" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 10,
      }}>
      <Box>
        <IconEnvioPendente width={60} />
        <Box marginY={2}>
          <p>
            <strong className="blue">Envio</strong>&nbsp;Pendente!
          </p>
        </Box>

        <Box marginY={2}>
          <p>
            Nós já enviamos as informações referentes ao envio do seu pedido. Verifique seu e-mail e, caso haja algum problema, entre em contato com o nosso
            SAC.
          </p>
        </Box>

        <Button onClick={onRequestClose}>Voltar</Button>
      </Box>
    </Modal>
  );
};

export default ModalEnvioPendente;
